import config from 'react-global-configuration';
import { FormikValues } from '../components/SearchAllContent/types';

export default async function mailOcularImages(values: FormikValues) {
  const API_URL = config.get('API_URL');

  const idsToExport = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(values)) {
    if (idsToExport.length > 99) {
      break;
    }

    if (key.match(/[0-9]/g) && value === true) {
      idsToExport.push(key);
    }
  }

  const response = await fetch(`${API_URL}/api/ocular_export_mailing?_format=json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ids: idsToExport,
      email: values.email,
    }),
  });

  const data = await response.json();

  return {
    status: response.status,
    data,
  };
}
